module.exports = __webpack_public_path__ + "img/IMG_8512_P_L_Wood_MockedUp.e94cff18.jpg";